module.exports = __webpack_public_path__ + "static/img/Games4all-WHITE.4824044.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/games4all/imgs/Games4all-WHITE.png
// module id = 1629
// module chunks = 0